const words = [
  "account",
  "act",
  "addition",
  "adjustment",
  "advertisement",
  "agreement",
  "air",
  "amount",
  "amusement",
  "angle",
  "animal",
  "answer",
  "ant",
  "apple",
  "approval",
  "arch",
  "argument",
  "arm",
  "army",
  "art",
  "attack",
  "attempt",
  "attention",
  "attraction",
  "authority",
  "baby",
  "back",
  "bag",
  "balance",
  "ball",
  "band",
  "base",
  "basket",
  "bath",
  "bed",
  "bee",
  "behaviour",
  "belief",
  "bell",
  "berry",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blood",
  "blow",
  "blue",
  "board",
  "boat",
  "body",
  "bone",
  "book",
  "boot",
  "bottle",
  "box",
  "boy",
  "brain",
  "branch",
  "brass",
  "bread",
  "breath",
  "brick",
  "bridge",
  "brother",
  "brush",
  "bucket",
  "building",
  "bulb",
  "burst",
  "business",
  "butter",
  "button",
  "cake",
  "camera",
  "canvas",
  "card",
  "care",
  "carriage",
  "cart",
  "cat",
  "chain",
  "chalk",
  "chance",
  "change",
  "cheese",
  "chemical",
  "chest",
  "chief",
  "chin",
  "church",
  "circle",
  "clock",
  "cloth",
  "cloud",
  "coal",
  "collar",
  "colour",
  "comb",
  "come",
  "comfort",
  "committee",
  "company",
  "comparison",
  "competition",
  "condition",
  "connection",
  "conscious",
  "control",
  "copper",
  "cotton",
  "country",
  "cow",
  "credit",
  "crime",
  "crush",
  "cup",
  "damage",
  "danger",
  "daughter",
  "day",
  "dear",
  "debt",
  "decision",
  "degree",
  "design",
  "desire",
  "destruction",
  "detail",
  "development",
  "direction",
  "discovery",
  "discussion",
  "disease",
  "distance",
  "distribution",
  "division",
  "dog",
  "door",
  "drawer",
  "dress",
  "dust",
  "ear",
  "earth",
  "east",
  "edge",
  "education",
  "effect",
  "egg",
  "end",
  "engine",
  "error",
  "event",
  "example",
  "exchange",
  "existence",
  "expansion",
  "experience",
  "expert",
  "eye",
  "face",
  "fact",
  "family",
  "farm",
  "father",
  "feather",
  "feeble",
  "female",
  "field",
  "fight",
  "finger",
  "fire",
  "fish",
  "flag",
  "flame",
  "flight",
  "floor",
  "flower",
  "fly",
  "food",
  "foot",
  "force",
  "fork",
  "frame",
  "friend",
  "front",
  "fruit",
  "future",
  "garden",
  "girl",
  "glass",
  "glove",
  "goat",
  "gold",
  "government",
  "grass",
  "group",
  "growth",
  "guide",
  "gun",
  "hair",
  "hammer",
  "hand",
  "harmony",
  "hat",
  "head",
  "heart",
  "heat",
  "help",
  "history",
  "hole",
  "hook",
  "hope",
  "horn",
  "horse",
  "hospital",
  "hour",
  "house",
  "humour",
  "ice",
  "idea",
  "impulse",
  "industry",
  "ink",
  "insect",
  "instrument",
  "insurance",
  "invention",
  "iron",
  "island",
  "jelly",
  "jewel",
  "journey",
  "judge",
  "kettle",
  "key",
  "kiss",
  "knee",
  "knife",
  "knowledge",
  "land",
  "language",
  "law",
  "leaf",
  "leather",
  "leg",
  "letter",
  "level",
  "library",
  "like",
  "limit",
  "line",
  "lip",
  "liquid",
  "list",
  "lock",
  "loss",
  "love",
  "machine",
  "male",
  "man",
  "manager",
  "map",
  "mark",
  "market",
  "mass",
  "meal",
  "measure",
  "meat",
  "medical",
  "meeting",
  "memory",
  "metal",
  "middle",
  "milk",
  "mind",
  "minute",
  "mist",
  "money",
  "monkey",
  "month",
  "moon",
  "morning",
  "mother",
  "motion",
  "mountain",
  "mouth",
  "muscle",
  "music",
  "nail",
  "name",
  "narrow",
  "nation",
  "neck",
  "needle",
  "nerve",
  "net",
  "news",
  "night",
  "noise",
  "north",
  "nose",
  "note",
  "number",
  "nut",
  "observation",
  "office",
  "oil",
  "operation",
  "opinion",
  "orange",
  "order",
  "organization",
  "ornament",
  "owner",
  "page",
  "paint",
  "paper",
  "parcel",
  "part",
  "past",
  "payment",
  "peace",
  "pen",
  "pencil",
  "person",
  "picture",
  "pig",
  "pin",
  "pipe",
  "place",
  "plane",
  "plant",
  "plate",
  "pleasure",
  "pocket",
  "point",
  "poison",
  "position",
  "pot",
  "potato",
  "powder",
  "power",
  "present",
  "price",
  "print",
  "prison",
  "process",
  "profit",
  "property",
  "prose",
  "protest",
  "punishment",
  "purpose",
  "quality",
  "question",
  "rail",
  "rain",
  "range",
  "rat",
  "ray",
  "reaction",
  "reason",
  "record",
  "relation",
  "religion",
  "request",
  "respect",
  "reward",
  "rhythm",
  "rice",
  "ring",
  "river",
  "road",
  "rod",
  "roof",
  "room",
  "root",
  "rule",
  "sail",
  "salt",
  "sand",
  "scale",
  "school",
  "science",
  "scissors",
  "sea",
  "seat",
  "secret",
  "seed",
  "selection",
  "sense",
  "shade",
  "shame",
  "sheep",
  "shelf",
  "ship",
  "shirt",
  "shock",
  "shoe",
  "side",
  "sign",
  "sister",
  "size",
  "skin",
  "skirt",
  "sky",
  "sleep",
  "slope",
  "smell",
  "smile",
  "smoke",
  "snake",
  "snow",
  "soap",
  "society",
  "sock",
  "son",
  "song",
  "sound",
  "soup",
  "south",
  "space",
  "sponge",
  "spoon",
  "spring",
  "square",
  "stage",
  "star",
  "start",
  "statement",
  "station",
  "steam",
  "steel",
  "step",
  "stick",
  "stomach",
  "stone",
  "story",
  "street",
  "structure",
  "substance",
  "sugar",
  "suggestion",
  "summer",
  "sun",
  "support",
  "surprise",
  "sweet",
  "swim",
  "system",
  "table",
  "tail",
  "talk",
  "taste",
  "tendency",
  "test",
  "theory",
  "thing",
  "throat",
  "thumb",
  "thunder",
  "ticket",
  "time",
  "tomorrow",
  "tongue",
  "tooth",
  "top",
  "town",
  "trade",
  "train",
  "transport",
  "tray",
  "tree",
  "trick",
  "trouble",
  "trousers",
  "turn",
  "twist",
  "umbrella",
  "unit",
  "value",
  "vessel",
  "view",
  "violent",
  "voice",
  "walk",
  "wall",
  "war",
  "watch",
  "water",
  "wave",
  "way",
  "weather",
  "week",
  "weight",
  "well",
  "west",
  "wheel",
  "whip",
  "whistle",
  "wind",
  "window",
  "wine",
  "wing",
  "winter",
  "wire",
  "woman",
  "wood",
  "wool",
  "word",
  "work",
  "wound",
  "writing",
  "year",
  "yesterday",
  "young",
];

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

interface options {
  minLength?: number;
  maxLength?: number;
}
export const getWord = ({ minLength: minSize = 0, maxLength: maxSize = 9999 }: options): string => {
  const potentialWords = words.filter(word => word.length >= minSize && word.length <= maxSize);
  const wordIndex = getRandomInt(potentialWords.length - 1);
  return potentialWords[wordIndex];
};
